module.exports = __webpack_public_path__ + "img/138.14abd4a9.jpg";